import React, { useEffect, useMemo, useRef, useState } from 'react';
import PaginationComponent from '../../shared/components/PaginationComponent';
import AddEditCommanTasks from '../components/forms/AddEditCommanTasksTemplate';
import Modal from '../../shared/components/ui/Modal';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Button from '../../shared/components/ui/Button';
import FormInput from '../../shared/components/ui/FormInput';
import { Pencil, Trash, Plus, CirclePlus } from 'lucide-react';
import { SwipeableDrawer } from '@mui/material';
import InfiniteScroll from 'react-infinite-scroll-component';
import {
  getContractorAndArchitect,
  updateLiveTask,
  makePreviewFalse,
  getAllIndependentLiveTask,
  createIndependentLiveTasks,
  getUnitsByProjectId,
  addAccIndependentLiveTasks,
  updateAllTaskUsers,
  getAllWorkTypes,
  updateAllTaskSPs,
  deleteLiveTask,
  checkLiveTaskDelete,
  bulkDeleteLiveTask,
  assignUsersByCheckbox,
  getTaskTemplates,
  bulkCompleteTasks,
  cancelCreatedLiveTask
} from '../services/api/implementation/impl';
import { useMutation, useQuery, useInfiniteQuery } from '@tanstack/react-query';
import DP from '../../shared/assets/svg/noUser.svg';
import toast from 'react-hot-toast';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import noDataIcon from '../../shared/assets/svg/NoData.svg';
import { getUsers } from '../../super-admin/services/api/implementation/impl';
import TaskDetailsPage from './TaskDetailsPage';
import { useNavigate } from 'react-router-dom';
import CalenderIcon from '../../shared/assets/svg/calendar.svg';
import AddEditAccIndependentTask from '../components/forms/AddEditAccIndependentTask';
import { useSidebar } from '../../shared/contexts/SidebarContext';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { setFormData } from '../../../uiSlice';
import DeleteConfirmationModal from '../components/ui/DeleteConfirmationModal';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';
import UserSelectionModal from '../components/forms/UserSelectionModal';
import BulkCompleteModal from '../components/forms/BulkCompleteModal';
import Loader from '../../shared/components/ui/Loader';
import TableData from '../../shared/components/ui/TableData';
import BulkEngineerAssignmentModal from '../components/layout/BulkEngineerAssignmentModal';
import BulkContractorAssignmentModal from '../components/layout/BulkContractorAssignmentModal';
import BulkActionModal from '../components/forms/BulkActionModal';
import { useProjectsList } from '../../../contexts/ProjectsContext';
import { AddServiceProvider } from '../components/forms/AddEditServiceProvider';
import { createServiceProvider } from '../services/api/implementation/impl';

const IndependentLiveTasks = ({ setisLoading }) => {
  const userId = Cookies.get('userId');
  const { projects, projectsForDropdown, isProjectsLoading } = useProjectsList();
  const dispatch = useDispatch();
  const storedFormData = useSelector((state) => state.ui.formData?.independent || {});
  const validationSchema = yup.object().shape({
    project: yup.string().required('Select Project'),
    unit: yup.string().required('Select Unit') // Make unit optional (nullable)
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    control,
    resetField,
    watch
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      block: '' // Ensure block has a default value.
    }
  });
  const { collapsed } = useSidebar();
  const [isOpenAddEditModal, setIsOpenAddEditModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const [isDateModalOpen, setIsDateModalOpen] = useState(false);
  const [selectedDateType, setSelectedDateType] = useState(''); // 'start' or 'end'
  const [selectedTaskId, setSelectedTaskId] = useState(null);
  const [tempDate, setTempDate] = useState(null); // temp selected date
  const [modalOpen, setModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalData, setModalData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [AllUsers, setAllUsers] = useState([]);
  const [AllContractors, setAllContractors] = useState([]);
  const [AllArchitect, setAllArchitect] = useState([]);
  const colors = ['bg-orange-400', 'bg-blue-500', 'bg-green-500', 'bg-purple-500']; // Add more if needed
  const [apiType, setApiType] = useState();
  const navigate = useNavigate();
  const [hidePreviewBtn, setHidePreviewBtn] = useState(false);
  const [hidePreviewTable, setHidePreviewTable] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [previousTask, setPreviousTask] = useState();
  const projectId = watch('project');
  const unitID = watch('unit');
  const [unique, setUnique] = useState(false);
  const userColorMap = {};
  const [allAssignedSPs, setAllAssignedSPs] = useState();
  const selectedWorkType = watch('workType');
  const [taskPositionType, setTaskPositionType] = useState();
  const [canDelete, setCanDelete] = useState(null);
  const [resData, setResData] = useState();
  const [selectedIds, setSelectedIds] = useState([]);
  const [isBulk, setIsBulk] = useState(false);
  const [selectItems, setSelectItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isAssignUsersModalOpen, setIsAssignUsersModalOpen] = useState(false);
  const [selectedEngineers, setSelectedEngineers] = useState([]);
  const [selectedContractors, setSelectedContractors] = useState([]);
  const [isBulkCompleteModalOpen, setIsBulkCompleteModalOpen] = useState(false);

  // Engineer bulk assignment modal state
  const [isEngineerBulkAssignModalOpen, setIsEngineerBulkAssignModalOpen] = useState(false);
  // Contractor bulk assignment modal state
  const [isContractorBulkAssignModalOpen, setIsContractorBulkAssignModalOpen] = useState(false);
  // Bulk action modal state
  const [isBulkActionModalOpen, setIsBulkActionModalOpen] = useState(false);

  // Add Service Provider modal state
  const [showAddSPModal, setShowAddSPModal] = useState(false);
  const [isSubmittingSP, setIsSubmittingSP] = useState(false);

  // Mutation for creating service provider
  const { mutate: handleCreateServiceProvider } = useMutation({
    mutationFn: createServiceProvider,
    onMutate: () => {
      setIsSubmittingSP(true);
    },
    onSuccess: async (data) => {
      setIsSubmittingSP(false);
      toast.success('Service Provider created successfully');
      setShowAddSPModal(false);
      // Refetch contractors or architects based on modal title
      if (modalTitle === 'Select Contractors') {
        await ContractorsMutation();
      } else if (modalTitle === 'Select Architects') {
        await ArchitectsMutation();
      }
    },
    onError: (err) => {
      setIsSubmittingSP(false);
      toast.error(
        err?.response?.data?.message || err?.message || 'Error creating service provider'
      );
    }
  });

  // Infinite scroll state (simplified)
  const [allTasks, setAllTasks] = useState([]);
  const limit = 50; // Page size for infinite scroll

  function getUserColor(userId) {
    if (!userColorMap[userId]) {
      const keys = Object.keys(userColorMap);
      userColorMap[userId] = colors[keys.length % colors.length];
    }
    return userColorMap[userId];
  }

  const [AllWorkTypes, setAllWorkTypes] = useState([]);

  const { mutate: fetchWorkTypes } = useMutation({
    mutationFn: () => getAllWorkTypes(),
    onMutate: () => {
      setIsSubmitting(true);
    },
    onSuccess: async (res) => {
      setAllWorkTypes(res);
      setIsSubmitting(false);
    },
    onError: (err) => {
      setIsSubmitting(false);
      toast.error(err?.response?.data?.message || err?.message || 'Error fetching work types');
    }
  });

  const { data: AllUnits, refetch: refetchUnits } = useQuery({
    queryKey: ['blocks', projectId],
    queryFn: () => getUnitsByProjectId(projectId),
    enabled: !!projectId
  });

  const { data: TaskTemplates, refetch: refetchTaskTemplates } = useQuery({
    queryKey: ['getTaskTemplates', projectId],
    queryFn: () => getTaskTemplates(projectId, 'independent'),
    enabled: !!projectId,
    refetchOnWindowFocus: true, // Refetch when user comes back to the page
    refetchOnMount: true // Refetch every time component mounts
  });

  // Refetch task templates when component mounts and project is available
  useEffect(() => {
    if (projectId) {
      refetchTaskTemplates();
    }
  }, [projectId, refetchTaskTemplates]);

  // Track page view
  useEffect(() => {
    mixpanel.track('Independent Live Tasks Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  useEffect(() => {
    if (projectId) refetchUnits();
  }, [projectId]);

  const { mutate: UsersMutation } = useMutation({
    mutationFn: () => getUsers(),
    onMutate: () => {
      setIsSubmitting(true);
    },
    onSuccess: async (res) => {
      setAllUsers(res);
      setIsSubmitting(false);

      // Process users immediately after setting state
      const usersArray = res?.data || res;
      const filteredUsers = usersArray
        .filter((user) => {
          return (
            user.vertical === 'Operations' &&
            Array.isArray(user.userProjectMapping) &&
            user.userProjectMapping.some(
              (mapping) => String(mapping.project_id) === String(projectId)
            )
          );
        })
        .map((user) => ({
          user: {
            id: user.id,
            name: user.name,
            level: user.level
          }
        }));

      setAllUsers(filteredUsers);
    },
    onError: (err) => {
      setIsSubmitting(false);
      toast.error(err?.response?.data?.message || err?.message || 'Error fetching users');
    }
  });

  const { mutate: ContractorsMutation } = useMutation({
    mutationFn: () => getContractorAndArchitect(1),
    onMutate: () => {
      setIsSubmitting(true);
    },
    onSuccess: async (res) => {
      setAllContractors(res);
      setIsSubmitting(false);
    },
    onError: (err) => {
      setIsSubmitting(false);
      toast.error(err?.response?.data?.message || err?.message || 'Error fetching contractors');
    }
  });

  const { mutate: ArchitectsMutation } = useMutation({
    mutationFn: () => getContractorAndArchitect(2),
    onMutate: () => {
      setIsSubmitting(true);
    },
    onSuccess: async (res) => {
      setAllArchitect(res);
      setIsSubmitting(false);
    },
    onError: (err) => {
      setIsSubmitting(false);
      toast.error(err?.response?.data?.message || err?.message || 'Error fetching architects');
    }
  });

  // Handle modal data updates when AllUsers changes
  useEffect(() => {
    if (AllUsers && modalTitle === 'Select Engineers') {
      setModalData(AllUsers);

      // For column add button (bulk assignment), do smart pre-selection
      if (unique) {
        const smartSelectedEngineers = AllUsers.filter((engineer) => {
          const assignedTasks = tasks.filter((task) =>
            task?.engineerLiveTaskMapping?.some((eng) => eng.user?.id === engineer.user?.id)
          );
          return assignedTasks.length === tasks.length && tasks.length > 0;
        }).map((eng) => eng.user?.id);
        setSelectedItems(smartSelectedEngineers);
      }
    }
  }, [AllUsers, modalTitle, unique, tasks]);

  // Handle modal data updates when AllContractors changes
  useEffect(() => {
    if (AllContractors && modalTitle === 'Select Contractors') {
      setModalData(AllContractors?.data);

      // For column add button (bulk assignment), do smart pre-selection
      if (unique) {
        const smartSelectedContractors =
          AllContractors?.data
            ?.filter((contractor) => {
              const assignedTasks = tasks.filter((task) =>
                task?.spLiveTaskMapping?.some(
                  (sp) =>
                    sp?.user?.serviceProvider?.category_id === 1 &&
                    sp.user?.id === contractor.user?.id
                )
              );
              return assignedTasks.length === tasks.length && tasks.length > 0;
            })
            .map((contractor) => contractor.user?.id) || [];

        setSelectedItems(smartSelectedContractors);

        const allAssignedArchitectIds = tasks?.reduce((acc, task) => {
          const architectIds =
            task?.spLiveTaskMapping
              ?.filter((sp) => sp?.user?.serviceProvider?.category_id === 2)
              .map((sp) => sp.user?.id)
              .filter(Boolean) || [];
          return acc.concat(architectIds);
        }, []);
        setAllAssignedSPs([...new Set(allAssignedArchitectIds)]);
      }
    }
  }, [AllContractors, modalTitle, unique, tasks]);

  // Handle modal data updates when AllArchitect changes
  useEffect(() => {
    if (AllArchitect && modalTitle === 'Select Architects') {
      setModalData(AllArchitect?.data);

      // For column add button (bulk assignment), do smart pre-selection
      if (unique) {
        const smartSelectedArchitects =
          AllArchitect?.data
            ?.filter((architect) => {
              const assignedTasks = tasks.filter((task) =>
                task?.architectLiveTaskMapping?.some(
                  (sp) =>
                    sp?.user?.serviceProvider?.category_id === 2 &&
                    sp.user?.id === architect.user?.id
                )
              );
              return assignedTasks.length === tasks.length && tasks.length > 0;
            })
            .map((architect) => architect.user?.id) || [];

        setSelectedItems(smartSelectedArchitects);

        const allAssignedContractorIds = tasks?.reduce((acc, task) => {
          const architectIds =
            task?.architectLiveTaskMapping
              ?.filter((sp) => sp?.user?.serviceProvider?.category_id === 1)
              .map((sp) => sp.user?.id)
              .filter(Boolean) || [];
          return acc.concat(architectIds);
        }, []);
        setAllAssignedSPs([...new Set(allAssignedContractorIds)]);
      }
    }
  }, [AllArchitect, modalTitle, unique, tasks]);

  const isQueryEnabled = Boolean(projectId && projectId !== '' && unitID && unitID !== '');

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch: refetchCommonLiveTask,
    isFetching
  } = useInfiniteQuery({
    queryKey: ['getAllIndependentLiveTask', projectId, unitID],
    queryFn: ({ pageParam = 1 }) => {
      if (!projectId || !unitID) {
        return Promise.resolve({ data: [], meta: { total: 0, page: 1, limit: 50 } });
      }
      // return getAllIndependentLiveTask(projectId, unitID, pageParam, limit);
      return getAllIndependentLiveTask(projectId, unitID);
    },
    getNextPageParam: (lastPage) => {
      // Use meta data to determine if there's a next page
      const { meta } = lastPage || {};
      if (meta && meta.total && meta.page && meta.limit) {
        const totalPages = Math.ceil(meta.total / meta.limit);
        const nextPage = meta.page + 1;
        return nextPage <= totalPages ? nextPage : undefined;
      }
      return undefined;
    },
    enabled: isQueryEnabled,
    initialPageParam: 1
  });

  useEffect(() => {
    setisLoading(isFetching);
  }, [isFetching]);

  useEffect(() => {
    if (data?.pages) {
      // Flatten all pages into a single array
      const allTasks = data.pages.flatMap((page) => page.data || []);
      setAllTasks(allTasks);
      setTasks(allTasks);

      const allAdded = allTasks?.length > 0 && allTasks?.every((task) => task?.isAdded);
      setHidePreviewBtn(allAdded);

      const isPreviewComplete = allTasks?.length > 0 && allTasks?.every((task) => !task?.preview);
      setHidePreviewTable(isPreviewComplete);
    }
  }, [data]);

  //refetch vendors when component mounts
  useEffect(() => {
    refetchCommonLiveTask();
  }, []);

  const loadMore = () => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  };

  const resetPagination = () => {
    // Reset the infinite query
    refetchCommonLiveTask();
  };

  const transformedDataTaskTemplates =
    TaskTemplates?.map((item) => ({
      label: item.name || '',
      id: item.name,
      value: item.name
    })) || [];

  const transformedDataUnits =
    AllUnits?.filter(
      (item) =>
        item.accommodation?.accomodationType === 'INDEPENDENT' &&
        item.accommodation?.numberOfFloors !== null
    )
      ?.map((item) => ({
        label: item.unitName || '',
        id: item.id,
        value: item.id
      }))
      .sort((a, b) => a.label.localeCompare(b.label)) || [];

  const transformedDataWorkTypes =
    AllWorkTypes?.filter((item) => {
      console.log('WorkType item:', item); // Debug log
      return item.type === 'Accommodation' || item.type === 'Accomodation'; // Handle both spellings
    }).map((item) => ({
      label: item.name || '',
      id: item.id,
      value: item.id
    })) || [];

  useEffect(() => {
    if (projects) {
      setValue('project', projects?.[0]?.id);
    }
  }, [projects]);

  useEffect(() => {
    if (AllUnits) {
      const validUnits = AllUnits?.filter(
        (item) =>
          item?.accommodation?.accomodationType === 'INDEPENDENT' &&
          item?.accommodation?.numberOfFloors !== null
      );

      if (validUnits.length > 0) {
        setValue('unit', validUnits?.[0]?.id); // default to first valid unit
      }
    }
  }, [AllUnits]);

  const handleDateClick = (taskId, type) => {
    setSelectedTaskId(taskId);
    setSelectedDateType(type);
    setIsDateModalOpen(true);
  };

  const handleDateSubmit = () => {
    if (!tempDate || !selectedTaskId || !selectedDateType) return;
    const formattedDate = tempDate?.toLocaleDateString('en-CA');
    let payload = {}; // <-- changed from const to let
    if (selectedDateType === 'start') {
      payload = {
        planned_start_date: formattedDate
      };
    }

    if (selectedDateType === 'end') {
      payload = {
        planned_end_date: formattedDate
      };
    }

    updateTask({ selectedTaskId, payload });
    setIsDateModalOpen(false);
    setTempDate(null);
    setSelectedTaskId(null);
    setSelectedDateType('');
  };

  // Bulk completion handlers
  const handleBulkCompleteClick = () => {
    fetchWorkTypes();
    setIsBulkCompleteModalOpen(true);
  };

  const handleBulkCompleteSubmit = async (payload) => {
    try {
      // Add project_id to the payload
      const fullPayload = {
        task_ids: payload.taskIds
      };

      console.log('fullPayload', fullPayload);
      // Call bulk completion API
      await bulkCompleteTasks(fullPayload);

      toast.success(`${payload.taskIds.length} task(s) completed successfully`);
      setIsBulkCompleteModalOpen(false);
      resetPagination();
      await refetchCommonLiveTask();
    } catch (error) {
      console.error('Error completing tasks:', error);
      toast.error(error?.response?.data?.message || error?.message || 'Error completing tasks');
    }
  };

  const { mutate: updateTask } = useMutation({
    mutationFn: ({ selectedTaskId, payload }) => updateLiveTask(selectedTaskId, payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      toast.success('Task updated successfully');
      resetField('workType');
      resetPagination();
      await refetchCommonLiveTask();
      setTaskPositionType();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error updating task', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error updating task');
    }
  });

  const toggleSelect = (item) => {
    // item is userId passed from render loop
    const userId = item;

    // Check if this is engineer selection and apply type restrictions
    if (modalTitle === 'Select Engineers') {
      const isSelected = selectedItems.some((s) => s.id === userId);

      if (!isSelected) {
        // Check if adding this engineer would exceed limits
        const user = modalData.find((u) => u.user?.id === userId);
        if (user && user.user?.level) {
          // Resolve current selected items to user objects
          const selectedEngineers = modalData.filter((u) =>
            selectedItems.some((s) => s.id === u.user?.id)
          );

          const mediumLevelCount = selectedEngineers.filter(
            (u) => u.user?.level === 'Medium'
          ).length;
          const lowLevelCount = selectedEngineers.filter(
            (u) => u.user?.level === 'Low'
          ).length;

          if (user.user.level === 'Medium' && mediumLevelCount >= 1) {
            toast.error('Only 1 Medium level engineer can be selected');
            return;
          }
          if (user.user.level === 'Low' && lowLevelCount >= 1) {
            toast.error('Only 1 Low level engineer can be selected');
            return;
          }
        }
      }
    }

    setSelectedItems((prevSelected) => {
      const isSelected = prevSelected.some((s) => s.id === userId);
      if (isSelected) {
        return prevSelected.filter((s) => s.id !== userId);
      } else {
        return [...prevSelected, { id: userId }];
      }
    });
  };

  const { mutate: updateTaskUsers } = useMutation({
    mutationFn: (payload) => updateAllTaskUsers(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      toast.success('Task updated successfully');
      resetField('workType');
      resetPagination();
      await refetchCommonLiveTask();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error updating task', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error updating task');
    }
  });

  const { mutate: updateTaskSPs } = useMutation({
    mutationFn: (payload) => updateAllTaskSPs(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      toast.success('Task updated successfully');
      setUnique(false);
      resetField('workType');
      resetPagination();
      await refetchCommonLiveTask();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error updating task', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error updating task');
    }
  });

  const handleAddClick = () => {
    if (unique && modalTitle === 'Select Contractors') {
      if (!selectedWorkType || selectedWorkType === '') {
        toast.error('Select WorkType');
        return;
      }
    }

    const sps = allTasks
      .filter((task) => task.workType_id === Number(selectedWorkType))
      .flatMap((task) => task.spLiveTaskMapping.map((sp) => sp.user?.id) || []);

    let payload = {}; // <-- changed from const to let
    if (modalTitle === 'Select Contractors' || modalTitle === 'Select Architects') {
      const SPids = [...new Set([...selectedItems.map((item) => item.id), ...allAssignedSPs])];
      const bulkSPs = [...new Set([...selectedItems.map((item) => item.id), ...sps])];
      if (unique) {
        if (modalTitle === 'Select Architects') {
          payload = {
            architect_ids: bulkSPs || [],
            taskType: 'Independent',
            unit_id: unitID
          };
        }
      }
      if (!unique) {
        if (modalTitle === 'Select Contractors') {
          payload = {
            sp_ids: SPids,
            taskType: 'Independent',
            unit_id: unitID
          };
        }

        if (modalTitle === 'Select Architects') {
          payload = {
            architect_ids: SPids,
            taskType: 'Independent',
            unit_id: unitID
          };
        }
      }
    }

    if (modalTitle === 'Select Engineers') {
      const selectedEngineers = modalData.filter((u) =>
        selectedItems.some((s) => s.id === u.user?.id)
      );

      const mediumLevelCount = selectedEngineers.filter((u) => u.user?.level === 'Medium').length;
      const lowLevelCount = selectedEngineers.filter((u) => u.user?.level === 'Low').length;

      if (mediumLevelCount !== 1) {
        toast.error('Please select exactly one Manager');
        return;
      }
      if (lowLevelCount !== 1) {
        toast.error('Please select exactly one Executive');
        return;
      }

      payload = {
        engineer_ids: selectedItems.map((item) => item.id),
        taskType: 'Independent',
        unit_id: unitID
      };
    }

    console.log('PAYLOAD', payload);

    if (unique) {
      if (modalTitle === 'Select Architects' || modalTitle === 'Select Engineers') {
        updateTaskUsers(payload);
      }
      if (modalTitle === 'Select Contractors') {
        updateTaskSPs(payload);
      }
    }
    if (!unique) {
      updateTask({ selectedTaskId, payload });
    }
    setModalOpen(false);
  };

  const handleImageClick = (id, type) => {
    setSelectedTaskId(id); // Set the currently focused task ID

    // Find the task data to get assigned users
    const currentTask = tasks?.find((task) => task?.id === id);

    let currentlyAssignedIds = [];

    if (currentTask) {
      if (type === 'engineer') {
        setModalTitle('Select Engineers');
        UsersMutation();
        currentlyAssignedIds =
          currentTask.engineerLiveTaskMapping?.map((eng) => ({
            id: eng.user?.id,
            workType_id: currentTask.workType_id
          })) || [];
      } else if (type === 'contractor') {
        setModalTitle('Select Contractors');
        ContractorsMutation();
        currentlyAssignedIds =
          currentTask.spLiveTaskMapping
            ?.filter((sp) => sp?.user?.serviceProvider?.category_id === 1)
            .map((sp) => ({
              id: sp.user?.id,
              workType_id: currentTask.workType_id
            })) || [];
        const allids =
          currentTask.spLiveTaskMapping
            ?.filter((sp) => sp?.user?.serviceProvider?.category_id === 2)
            .map((sp) => sp.user?.id) || [];
        setAllAssignedSPs(allids);
      } else if (type === 'architect') {
        setModalTitle('Select Architects');
        ArchitectsMutation();
        currentlyAssignedIds =
          currentTask.architectLiveTaskMapping
            ?.filter((sp) => sp?.user?.serviceProvider?.category_id === 2)
            .map((sp) => ({
              id: sp.user?.id,
              workType_id: currentTask.workType_id
            })) || [];
        const allids =
          currentTask.architectLiveTaskMapping
            ?.filter((sp) => sp?.user?.serviceProvider?.category_id === 1)
            .map((sp) => sp.user?.id) || [];
        setAllAssignedSPs(allids);
      }
      setSelectedItems(currentlyAssignedIds);
    } else if (id === null && type === 'engineer') {
      // Handle the case for adding engineers to all tasks (CirclePlus button)
      setModalTitle('Select Engineers');
      UsersMutation();
      setUnique(true);
    } else if (id === null && type === 'contractor') {
      fetchWorkTypes();

      // Handle the case for adding contractors to all tasks (CirclePlus button)
      setModalTitle('Select Contractors');
      ContractorsMutation();
      setUnique(true);
    } else if (id === null && type === 'architect') {
      // Handle the case for adding architects to all tasks (CirclePlus button)
      setModalTitle('Select Architects');
      ArchitectsMutation();
      setUnique(true);
    } else {
      // Reset if task not found or for other types if needed
      setModalTitle(`Select ${type.charAt(0).toUpperCase() + type.slice(1)}s`);
      UsersMutation();
      ContractorsMutation();
      ArchitectsMutation();
      setModalData([]);
      setSelectedItems([]);
    }

    setModalOpen(true);
  };
  const HandleCreate = (data) => {
    if (!watch('template_name')) {
      toast.error('Please select task template');
      return;
    }
    const payload = {
      unit_id: Number(data.unit) || null,
      name: watch('template_name')
    };

    createIndependentLive(payload);
  };

  const { mutate: createIndependentLive } = useMutation({
    mutationFn: (payload) => createIndependentLiveTasks(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      toast.success('Tasks created successfully');
      resetPagination();
      await refetchCommonLiveTask();
      setTaskPositionType();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error creating new tasks', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error creating tasks');
    }
  });

  useEffect(() => {
    console.log(errors);
  }, [errors]);

  const { mutate: savePreview } = useMutation({
    mutationFn: (payload) => makePreviewFalse(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      resetPagination();
      await refetchCommonLiveTask();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error saving preview', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error saving preview');
    }
  });

  const { mutate: cancelCreatedLiveTaskfn } = useMutation({
    mutationFn: (payload) => cancelCreatedLiveTask(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      resetPagination();
      await refetchCommonLiveTask();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error canceling created live task', err);
      toast.error(
        err?.response?.data?.message || err?.message || 'Error canceling created live task'
      );
    }
  });

  const formatDate = (dateString) => {
    if (!dateString) return null;

    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'short' }); // May, Jun, etc.
    const year = date.getFullYear();

    // Add "st", "nd", "rd", "th"
    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return 'th'; // 11th, 12th, 13th
      switch (n % 10) {
        case 1:
          return 'st';
        case 2:
          return 'nd';
        case 3:
          return 'rd';
        default:
          return 'th';
      }
    };

    return `${day}${getOrdinal(day)} ${month} ${year}`;
  };

  const [state, setState] = useState({
    right: false
  });

  const toggleDrawer = (anchor, open) => {
    setState((prevState) => ({ ...prevState, [anchor]: open }));
  };

  const HandleSavePreview = () => {
    const payload = {
      taskType: 'Independent',
      unit_id: Number(watch('unit'))
    };
    savePreview(payload);
  };

  const HandleCancelCreatedLiveTask = () => {
    const payload = {
      taskType: 'Independent',
      unit_id: Number(watch('unit'))
    };
    cancelCreatedLiveTaskfn(payload);
  };

  const handleAddTask = (data) => {
    const payload = {
      ...data,
      prevTask_id: previousTask.id,
      unit_id: unitID
    };
    AddIndependentLive(payload);
  };

  const { mutate: AddIndependentLive } = useMutation({
    mutationFn: (payload) =>
      modalType === 'Add'
        ? addAccIndependentLiveTasks(payload)
        : updateLiveTask(previousTask.id, payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      toast.success(`Tasks ${modalType === 'Add' ? 'created' : 'updated'} successfully`);
      resetPagination();
      setIsOpenAddEditModal(false);
      setTaskPositionType();
      await refetchCommonLiveTask();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error(`Error ${modalType === 'Add' ? 'creating new' : 'updating'}  task`, err);
      toast.error(
        err?.response?.data?.message ||
        err?.message ||
        `Error ${modalType === 'Add' ? 'creating new' : 'updating'} task`
      );
    }
  });

  const handleOnEdit = (id) => {
    const task = tasks?.find((item) => item?.id === Number(id)); // Use find() instead of filter()
    if (task) {
      setIsOpenAddEditModal(true);
      setModalType('Edit');
      setPreviousTask(task);
    }
  };

  useEffect(() => {
    setisLoading(isSubmitting);
  }, [isSubmitting]);

  function formatTasksByWorkType(tasks) {
    const grouped = {};

    tasks?.forEach((task) => {
      const workTypeName = task?.workType?.name;
      if (!grouped[workTypeName]) {
        grouped[workTypeName] = [];
      }
      grouped[workTypeName].push(task);
    });

    const formatted = [];

    for (const [workType, taskList] of Object.entries(grouped)) {
      const [first, ...rest] = taskList;

      const formattedGroup = {
        id: first.id,
        workType: workType,
        workType_id: first.workType_id,
        planned_end_date: first.planned_end_date,
        planned_start_date: first.planned_start_date,
        actual_end_date: first.actual_end_date,
        actual_start_date: first.actual_start_date,
        status: first.status,
        name: first.name,
        delay: `${first.delay} day${first.delay > 1 ? 's' : ''}`,
        Others: rest.map((task, i) => ({
          id: task.id,
          workType: workType,
          workType_id: task.workType_id,
          planned_end_date: task.planned_end_date,
          planned_start_date: task.planned_start_date,
          actual_end_date: task.actual_end_date,
          actual_start_date: task.actual_start_date,
          status: task.status,
          name: task.name,
          delay: `${task.delay} day${task.delay > 1 ? 's' : ''}`
        }))
      };

      formatted.push(formattedGroup);
    }

    return formatted;
  }

  const formatted = useMemo(() => formatTasksByWorkType(tasks), [tasks]);

  useEffect(() => {
    if (projectId) {
      dispatch(
        setFormData({
          subTab: 'independent',
          data: { projectId }
        })
      );
    }
  }, [projectId]);

  useEffect(() => {
    if (unitID) {
      dispatch(
        setFormData({
          subTab: 'independent',
          data: { unitID }
        })
      );
    }
  }, [unitID]);

  useEffect(() => {
    if (!projects?.length) return; // wait for both to be fetched

    if (storedFormData.projectId) {
      setValue('project', storedFormData.projectId);
    }
  }, [projects]);

  useEffect(() => {
    if (!AllUnits?.length) return; // wait for both to be fetched

    if (storedFormData.unitID) {
      setValue('unit', storedFormData.unitID);
    }
  }, [AllUnits]);

  //delete functions

  const { mutate: handleCheckDelete } = useMutation({
    mutationFn: (id) => checkLiveTaskDelete(id),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (res, id) => {
      setIsSubmitting(false);
      const task = tasks?.find((item) => parseInt(item.id) === parseInt(id));
      const taskName = task?.name || 'Task';
      if (res.canDelete) {
        setCanDelete('yes');
        setResData({ name: taskName });
        setSelectedIds([parseInt(id)]);
      } else {
        // Fallback if not found
        setResData({ ...res, name: taskName });
        setCanDelete('no');
      }
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error checking dependencies', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error checking dependencies');
    }
  });

  const { mutate: handleDeleteFn } = useMutation({
    mutationFn: (payload) => deleteLiveTask(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: () => {
      setIsSubmitting(false);
      toast.success('Task Deleted Successfully');
      resetPagination();
      refetchCommonLiveTask();
      setCanDelete(null);
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error deleting task', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error deleting task');
    }
  });

  const { mutate: handleBulkDeleteFn } = useMutation({
    mutationFn: (payload) => bulkDeleteLiveTask(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: () => {
      setIsSubmitting(false);
      toast.success('Task Deleted Successfully');
      resetPagination();
      refetchCommonLiveTask();
      setCanDelete(null);
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error deleting task', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error deleting task');
    }
  });

  const HandleDelete = (data) => {
    const payload = { ids: data };
    handleDeleteFn(payload);
  };

  const calculateDelay = (task) => {
    if (!task.planned_end_date) return '---';

    const plannedEnd = new Date(task.planned_end_date);
    const today = new Date();

    let delay;

    if (task.status === 'To Do' || task.status === 'In Progress') {
      delay = Math.floor((today - plannedEnd) / (1000 * 60 * 60 * 24)); // days
    } else if (task.status === 'Completed') {
      if (!task.actual_end_date) return '---';
      const actualEnd = new Date(task.actual_end_date);
      delay = Math.floor((actualEnd - plannedEnd) / (1000 * 60 * 60 * 24)); // days
    } else {
      return '---';
    }

    return delay > 0 ? `${delay} days` : '---';
  };

  const HandleBulkDelete = () => {
    const payload = { taskType: 'Independent', unit_id: unitID };
    handleBulkDeleteFn(payload);
  };

  const handleAssignUsersSubmit = async () => {
    if (selectedEngineers.length === 0 && selectedContractors.length === 0) {
      toast.error('Please select at least one employee or contractor');
      return;
    }

    // Validate employee level selection
    if (selectedEngineers.length > 0) {
      const selectedEmployeeData = AllUsers?.filter((user) =>
        selectedEngineers.includes(user.user.id)
      );
      const mediumLevelEmployees = selectedEmployeeData.filter(
        (user) => user.user.level === 'Medium'
      );
      const lowLevelEmployees = selectedEmployeeData.filter((user) => user.user.level === 'Low');

      if (mediumLevelEmployees.length > 1) {
        toast.error('Only one Medium level employee can be selected');
        return;
      }

      if (lowLevelEmployees.length > 1) {
        toast.error('Only one Low level employee can be selected');
        return;
      }

      if (mediumLevelEmployees.length === 0 && lowLevelEmployees.length === 0) {
        toast.error('Please select at least one Medium or Low level employee');
        return;
      }
    }

    const payload = {
      taskIds: selectedItems,
      engineer_ids: selectedEngineers,
      contractor_ids: selectedContractors
    };

    try {
      // You can call your API here with the payload
      console.log('Assign Users Payload:', payload);
      await assignUsersByCheckbox(payload);

      // Small delay to ensure backend processes the changes
      await new Promise((resolve) => setTimeout(resolve, 500));

      toast.success('Users assigned successfully');
      setIsAssignUsersModalOpen(false);
      setSelectedItems([]);
      setSelectedEngineers([]);
      setSelectedContractors([]);
      await refetchCommonLiveTask();
    } catch (error) {
      console.error('Error assigning users:', error);
      toast.error(error?.response?.data?.message || error?.message || 'Error assigning users');
    }
  };

  const handleSelectAll = async (e) => {
    const checked = e.target.checked;
    if (checked) {
      const results = tasks.map((item) => item.id);
      setSelectedItems(results);
      setSelectItems(results);
    } else {
      setSelectedItems([]);
      setSelectItems([]);
    }
  };

  // Update selectAll state based on selectedItems
  useEffect(() => {
    if (tasks.length > 0 && selectedItems.length === tasks.length) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [selectedItems, tasks.length]);

  const HandleFunctionCalls = (id, checked) => {
    if (checked) {
      setSelectedItems((prev) => [...prev, id]);
      setSelectItems((prev) => [...prev, id]);
    } else {
      setSelectedItems((prev) => prev.filter((item) => item !== id));
      setSelectItems((prev) => prev.filter((item) => item !== id));
    }
  };

  const handleAssignUsersClick = () => {
    setIsAssignUsersModalOpen(true);
    setSelectedEngineers([]);
    setSelectedContractors([]);
  };

  // Engineer bulk assignment handler
  const handleBulkEngineerAssignment = async ({
    selectedTasks,
    selectedEngineers,
    selectedWorkType
  }) => {
    const payload = {
      taskIds: selectedTasks,
      engineer_ids: selectedEngineers
    };
    setIsSubmitting(true);
    try {
      console.log('Bulk Engineer Assignment Payload:', payload);
      await assignUsersByCheckbox(payload);

      // Small delay to ensure backend processes the changes
      await new Promise((resolve) => setTimeout(resolve, 500));

      toast.success('Engineers assigned successfully');

      // Track success
      mixpanel.track('Bulk Engineer Assignment', {
        user_id: userId,
        task_count: selectedTasks.length,
        engineer_count: selectedEngineers.length,
        work_type: selectedWorkType
      });
      setIsEngineerBulkAssignModalOpen(false);
      resetPagination();
      await refetchCommonLiveTask();
    } catch (error) {
      console.error('Error assigning engineers:', error);
      toast.error(error?.response?.data?.message || error?.message || 'Error assigning engineers');

      // Track error
      mixpanel.track('Bulk Engineer Assignment Error', {
        user_id: userId,
        error: error.message
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  // Contractor bulk assignment handler
  const handleBulkContractorAssignment = async ({
    selectedTasks,
    selectedContractors,
    selectedWorkType,
    formattedData
  }) => {
    try {
      console.log('Bulk Contractor Assignment Payload:', {
        selectedTasks,
        selectedContractors,
        selectedWorkType,
        formattedData
      });

      // Use the old API and payload structure
      const payload = {
        sp_ids: selectedContractors,
        taskType: 'Independent',
        unit_id: unitID,
        workType_id: Number(selectedWorkType)
      };

      await updateTaskSPs(payload);

      toast.success('Contractors assigned successfully');

      // Track success
      mixpanel.track('Bulk Contractor Assignment', {
        user_id: userId,
        task_count: selectedTasks.length,
        contractor_count: selectedContractors.length,
        work_type: selectedWorkType
      });
      setIsContractorBulkAssignModalOpen(false);
      resetPagination();
      await refetchCommonLiveTask();
    } catch (error) {
      console.error('Error assigning contractors:', error);
      toast.error(
        error?.response?.data?.message || error?.message || 'Error assigning contractors'
      );

      // Track error
      mixpanel.track('Bulk Contractor Assignment Error', {
        user_id: userId,
        error: error.message
      });
    }
  };

  return (
    <div className="mt-[8rem] relative">
      <Loader isVisible={isSubmitting || isFetching || isProjectsLoading} />
      {isOpenAddEditModal && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          width={65}
          name={modalType === 'Edit' ? 'Edit Task' : 'Add Task'}
          onClose={() => setIsOpenAddEditModal(false)}>
          <AddEditAccIndependentTask
            isSubmitting={isSubmitting}
            onSubmit={handleAddTask}
            onClose={() => setIsOpenAddEditModal(false)}
            modalType={modalType}
            setModalType={setModalType}
            selectedTask={previousTask}
            tasks={tasks}
            taskPositionType={taskPositionType}
          />
        </Modal>
      )}

      {modalOpen && (
        <Modal
          isDirty={true}
          width={30}
          name={modalTitle}
          onClose={() => {
            setModalOpen(false);
            resetField('workType');
          }}>
          <div className="modal">
            {unique && modalTitle === 'Select Contractors' && (
              <FormInput
                width={48}
                label={'Work Type'}
                register={register}
                register_key={'workType'}
                isRequired={true}
                type={'dropdown'}
                options={[
                  { label: 'Select Worktype', value: '', disabled: true, selected: true },
                  ...transformedDataWorkTypes
                ]}
              />
            )}
            <div className="modal-body max-h-[300px] overflow-y-auto mt-4">
              {modalTitle === 'Select Engineers' && (
                <div className="mb-2 text-sm font-medium text-gray-600 bg-blue-50 p-2 rounded">
                  Required: 1 Manager + 1 Executive
                </div>
              )}
              {modalData && modalData.length > 0 ? (
                modalData.map((item) => {
                  const userId = item.user?.id;

                  // For contractors: check if assigned to same workType
                  const isSelected =
                    unique && modalTitle === 'Select Contractors'
                      ? selectedItems.some(
                        (selected) =>
                          selected.id === userId &&
                          selected.workType_id === Number(selectedWorkType)
                      )
                      : // For others: simple ID check
                      selectedItems.some((selected) => selected.id === userId);

                  // Check if this engineer should be disabled
                  let isDisabled = false;
                  if (modalTitle === 'Select Engineers' && !isSelected) {
                    const selectedEngineers = modalData.filter((u) =>
                      selectedItems.some((selected) => selected.id === u.user?.id)
                    );
                    const mediumLevelCount = selectedEngineers.filter(
                      (u) => u.user?.level === 'Medium'
                    ).length;
                    const lowLevelCount = selectedEngineers.filter(
                      (u) => u.user?.level === 'Low'
                    ).length;

                    if (item.user?.level === 'Medium' && mediumLevelCount >= 1) {
                      isDisabled = true;
                    }
                    if (item.user?.level === 'Low' && lowLevelCount >= 1) {
                      isDisabled = true;
                    }
                  }

                  const initials = item.user?.name
                    .split(' ')
                    .map((word) => word[0])
                    .join('')
                    .toUpperCase();

                  return (
                    <div
                      key={item.id || userId}
                      onClick={() => {
                        if (isDisabled) return;

                        if (unique && modalTitle === 'Select Contractors') {
                          if (!selectedWorkType || selectedWorkType === '') {
                            toast.error('Please select Worktype');
                            return;
                          }
                          // For contractors with workType, store both id and workType_id
                          const newItem = { id: userId, workType_id: Number(selectedWorkType) };
                          setSelectedItems((prev) => {
                            const exists = prev.some(
                              (i) => i.id === userId && i.workType_id === Number(selectedWorkType)
                            );
                            return exists
                              ? prev.filter(
                                (i) =>
                                  !(i.id === userId && i.workType_id === Number(selectedWorkType))
                              )
                              : [...prev, newItem];
                          });
                        } else {
                          // For others, maintain backward compatibility
                          setSelectedItems((prev) => {
                            const exists = prev.some((i) => i.id === userId);
                            return exists
                              ? prev.filter((i) => i.id !== userId)
                              : [...prev, { id: userId }];
                          });
                        }
                      }}
                      className={`flex items-center gap-3 p-3 mb-2 rounded-lg border ${isSelected
                        ? 'bg-green-100 cursor-pointer'
                        : isDisabled
                          ? 'bg-gray-100 cursor-not-allowed opacity-50'
                          : 'bg-white cursor-pointer hover:bg-gray-50'
                        }`}>
                      <div
                        className={`w-8 h-8 rounded-full text-white flex items-center justify-center font-semibold text-sm ${getUserColor(userId)}`}>
                        {initials}
                      </div>
                      <div className="flex-1">
                        <span className="text-gray-800 capitalize">{item.user?.name}</span>
                        {modalTitle === 'Select Engineers' && item.user?.level && (
                          <span className="ml-2 text-sm text-gray-500">
                            ({item.user.level === 'Medium' ? 'Manager' : 'Executive'})
                          </span>
                        )}
                      </div>
                      {isDisabled && (
                        <div className="text-xs text-gray-400">
                          {item.user?.level === 'Medium' ? 'Max 1 Medium' : 'Max 1 Low'}
                        </div>
                      )}
                    </div>
                  );
                })
              ) : (
                <p className="text-center text-gray-500">No users to display</p>
              )}
            </div>

            {modalData && modalData.length > 0 && (
              <div className="flex gap-2 justify-between items-center p-3">
                {(modalTitle === 'Select Contractors' || modalTitle === 'Select Architects') && (
                  <button
                    onClick={() => setShowAddSPModal(true)}
                    className="text-blue-500 hover:text-blue-700 text-sm font-semibold underline cursor-pointer">
                    Add
                  </button>
                )}
                <div className="flex gap-2 ml-auto">
                  <Button
                    customStyle={{ width: '7rem' }}
                    displayType={'secondary'}
                    onClick={() => {
                      setModalOpen(false);
                      setModalData([]);
                    }}>
                    Close
                  </Button>
                  <Button customStyle={{ width: '7rem' }} onClick={handleAddClick}>
                    Add
                  </Button>
                </div>
              </div>
            )}
          </div>
        </Modal>
      )}

      {isDateModalOpen && (
        <div className="h-screen w-screen bg-[#0000002a] z-[90] flex justify-center items-center fixed top-0 left-0">
          <div className="flex flex-col items-center p-1  bg-white rounded-lg">
            <DatePicker selected={tempDate} onChange={(date) => setTempDate(date)} inline />

            <div className="flex gap-4 mt-3 w-[100%] justify-end">
              <Button
                type="button"
                onClick={() => setIsDateModalOpen(false)}
                displayType="secondary">
                Cancel
              </Button>

              <Button type="button" onClick={() => handleDateSubmit()} disabled={!tempDate}>
                OK
              </Button>
            </div>
          </div>
        </div>
      )}

      {canDelete === 'no' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={`Cannot delete '${resData?.name || 'this task'}'`}
          onClose={() => {
            setCanDelete(null);
            setIsBulk(false);
            setSelectItems([]);
          }}
          width={45}>
          <div className="flex flex-col justify-center align-center ">
            <p className="text-center">
              Looks like this task has dependencies, please delete following task to proceed
            </p>
            <div className="flex justify-start, align-middle flex-wrap bg-[#f5f7f8] p-2 rounded-[5px] mt-4">
              {resData &&
                resData.reason?.map((r, index) => (
                  <span className="mt-[2px] mr-[4px] text-[#535353]" key={index}>
                    {index + 1}.{r}
                    {index < resData.reason.length - 1 ? ', ' : ''}
                  </span>
                ))}
            </div>
          </div>
          <div className="flex flex-col justify-start items-center mt-4 w-[100%]  bg-[#f7f4d0] pt-[4px] pb-[4px] pl-2 pr-2 rounded-[4px]">
            <div className="flex justify-between w-[99%] items-center bg-white p-2 pt-1 pb-1">
              <p>Would you like to delete more tasks ?</p>
              <div
                onClick={(e) => {
                  setIsBulk(!isBulk);
                  setSelectItems([]);
                  handleSelectAll(e);
                }}
                className="bg-amber-100 p-2 pt-1 pb-1 rounded-[5px] flex justify-center items-center gap-2 cursor-pointer">
                Bulk Delete
                <input
                  type="checkbox"
                  checked={isBulk}
                  readOnly
                  className="outline-none border-none"
                />
              </div>
            </div>
            {isBulk && (
              <div className="pl-[10px] w-[100%] pr-[19px] mt-2 mb-2 max-h-[14rem] overflow-auto">
                {tasks &&
                  tasks.map((c, index) => (
                    <div key={index} className="flex justify-between items-center text-[#5b5b5b]">
                      {index + 1}. {c.name}
                      <input
                        className="outline-none border-none"
                        type="checkbox"
                        checked={selectItems.includes(c.id)}
                      />
                    </div>
                  ))}
              </div>
            )}
          </div>

          <div className="w-full flex justify-end items-center space-x-4 mt-8">
            <Button
              type="reset"
              onClick={() => {
                setCanDelete(null);
                setIsBulk(false);
                setSelectItems([]);
              }}
              displayType="secondary">
              Cancel
            </Button>
            <Button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                HandleBulkDelete(selectItems);
              }}
              disabled={isSubmitting || selectItems.length === 0}
              displayType="primary-red">
              Delete
            </Button>
          </div>
        </Modal>
      )}

      {canDelete === 'yes' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={'Confirmation'}
          onClose={() => {
            setCanDelete(null);
            setSelectedIds([]);
          }}
          width={45}>
          <DeleteConfirmationModal
            name={resData.name}
            title={'task'}
            onClose={() => setCanDelete(null)}
            data={tasks}
            type={'commonLiveTask'}
            setCanDelete={setCanDelete}
            onDeleteClick={HandleDelete}
            setSelectedIds={setSelectedIds}
            selectedIds={selectedIds}
          />
        </Modal>
      )}

      <div
        className={`flex justify-between items-center gap-2 fixed  z-30 border  bg-white px-6 py-3 pb-6 mt-[-0.86rem]   transition-all duration-300 ease-in-out ${collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
          }`}>
        <form
          onSubmit={handleSubmit(HandleCreate)}
          className="flex justify-between items-end w-[100%]">
          <div className="flex justify-start items-center w-[80%] gap-3 flex-wrap">
            <FormInput
              width={23}
              label={'Project'}
              register={register}
              register_key={'project'}
              isRequired={true}
              type={'dropdown'}
              options={[
                { label: 'Select Project', value: '', disabled: true, selected: true }, // Add the "Select Project" option first
                ...projectsForDropdown
              ]}
              validation={{ required: 'Project is required' }}
              errors={errors}
            />

            <FormInput
              width={23}
              label={'Unit'}
              register={register}
              register_key={'unit'}
              isRequired={true}
              type={'dropdown'}
              options={[
                { label: 'Select Unit', value: '', disabled: true, selected: true }, // Add the "Select Project" option first
                ...transformedDataUnits
              ]}
              validation={{ required: 'Unit is required' }}
              errors={errors}
            />

            {tasks && tasks?.length < 1 && (
              <FormInput
                width={23}
                label={'Task Template'}
                register={register}
                register_key={'template_name'}
                isRequired={true}
                type={'dropdown'}
                options={[
                  { label: 'Select Task Template', value: '', disabled: true, selected: true },
                  ...transformedDataTaskTemplates
                ]}
                validation={{ required: 'Task template is required' }}
                errors={errors}
              />
            )}
          </div>

          {tasks && tasks?.length < 1 && (
            <Button
              customStyle={{
                height: '2.5rem',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
              disabled={isSubmitting}
              type="submit">
              Create
            </Button>
          )}

          {!hidePreviewTable && (
            <div className="flex justify-center gap-4">
              {/* {selectedItems.length >= 2 && (
                <Button
                  type={'button'}
                  customStyle={{ paddingLeft: '2rem', paddingRight: '2rem' }}
                  onClick={handleAssignUsersClick}>
                  Assign Users
                </Button>
              )} */}
              {tasks && tasks?.length > 0 && (
                <Button
                  type={'button'}
                  customStyle={{ paddingLeft: '1rem', paddingRight: '1rem', whiteSpace: 'nowrap' }}
                  onClick={handleBulkCompleteClick}>
                  Mark as Complete
                </Button>
              )}

              <Button
                type={'button'}
                disabled={!hidePreviewBtn}
                customStyle={{ paddingLeft: '3rem', paddingRight: '3rem' }}
                onClick={HandleSavePreview}>
                Save
              </Button>
              {tasks && tasks?.length > 0 && (
                <Button
                  type={'button'}
                  displayType={'secondary-red'}
                  customStyle={{ paddingLeft: '3rem', paddingRight: '3rem' }}
                  onClick={HandleCancelCreatedLiveTask}>
                  Cancel
                </Button>
              )}
            </div>
          )}
        </form>

        {hidePreviewTable && (
          <div className="flex gap-4">
            <Button
              onClick={() => setIsBulkActionModalOpen(true)}
              customStyle={{ paddingLeft: ' 1rem', paddingRight: '1rem', whiteSpace: 'nowrap' }}>
              Bulk Actions
            </Button>
            <Button
              onClick={() =>
                navigate('/builder/operations/tasks/ganttChart', {
                  state: { title: 'Independent Tasks', data: tasks }
                })
              }
              customStyle={{ paddingLeft: '1rem', paddingRight: '1rem', whiteSpace: 'nowrap' }}>
              Gantt Chart
            </Button>
          </div>
        )}
      </div>
      {!hidePreviewTable && (
        <div className={`${'pt-[7rem]'}`}>
          <div className="shadow overflow-auto rounded-lg">
            <InfiniteScroll
              dataLength={allTasks.length}
              next={loadMore}
              hasMore={hasNextPage}
              loader={
                <div className="flex justify-center items-center py-4">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                  <span className="ml-2 text-gray-600">Loading more tasks...</span>
                </div>
              }
              endMessage={
                <div className="flex justify-center items-center py-4">
                  <p className="text-gray-500">No more tasks to load</p>
                </div>
              }
              style={{ overflow: 'visible' }}>
              <table className="min-w-full rounded-t-xl text-left   shadow">
                <thead className=" bg-gray-200 !text-gray-600 w-full ">
                  <tr className="font-normal h-[3rem] w-full">
                    {/* <th className="px-4 py-2 border-b font-normal">
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleSelectAll}
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                    />
                  </th> */}
                    <th className="px-4 py-2 border-b font-normal ">ID</th>
                    <th className="px-4 py-2 border-b font-normal">Task Name</th>
                    <th className="px-4 py-2 border-b font-normal">Planned Start Date</th>
                    <th className="px-4 py-2 border-b font-normal">Planned End Date</th>
                    <th className="px-4 py-2 border-b relative font-normal">
                      <div className="flex gap-2 justify-center items-center">
                        Assign Employee
                        {tasks && tasks?.length > 0 && (
                          <CirclePlus
                            height={15}
                            width={15}
                            className="cursor-pointer"
                            onClick={(e) => {
                              fetchWorkTypes();
                              UsersMutation();
                              setIsEngineerBulkAssignModalOpen(true);
                              e.stopPropagation();
                            }}
                          />
                        )}
                      </div>
                    </th>
                    <th className="px-4 py-2 border-b font-normal">
                      <div className="flex gap-2 justify-center items-center">
                        Assign Contractor
                        {tasks && tasks.length > 0 && (
                          <CirclePlus
                            height={15}
                            width={15}
                            className="cursor-pointer"
                            onClick={(e) => {
                              e.stopPropagation();
                              ContractorsMutation();
                              fetchWorkTypes();
                              refetchUnits();
                              setIsContractorBulkAssignModalOpen(true);
                            }}
                          />
                        )}
                      </div>
                    </th>
                    <th className="px-4 py-2 border-b font-normal">
                      <div className="flex gap-2 justify-center items-center">
                        Assign Architect
                        {tasks && tasks.length > 0 && (
                          <CirclePlus
                            height={15}
                            width={15}
                            className="cursor-pointer"
                            onClick={(e) => {
                              handleImageClick(null, 'architect');
                              e.stopPropagation();
                            }}
                          />
                        )}
                      </div>
                    </th>
                    <th className="px-4 py-2 border-b font-normal ">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {tasks && tasks?.length > 0 ? (
                    tasks?.map((task, index) => {
                      return (
                        <React.Fragment key={task.id}>
                          <tr
                            className="border-b hover:bg-gray-50 bg-white h-[3.5rem]"
                            onClick={() => {
                              setApiType('independent');
                              setSelectedTaskId(task?.id);
                              toggleDrawer('right', true);
                            }}>
                            {/* <td className="px-4 py-2" onClick={(e) => e.stopPropagation()}>
                            <input
                              type="checkbox"
                              checked={selectedItems.includes(task?.id)}
                              onChange={(e) => HandleFunctionCalls(task?.id, e.target.checked)}
                              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                            />
                          </td> */}
                            <td className="px-4 py-2 text-blue-600 underline cursor-pointer">
                              {index + 1}
                            </td>
                            <td className="px-4 py-2">{task?.name}</td>
                            <td className="px-4 py-2">
                              {task.status !== 'Completed' &&
                                (task.planned_start_date ? (
                                  formatDate(task?.planned_start_date)
                                ) : task?.dependencies?.length > 0 &&
                                  !task?.dependencies?.some(
                                    (item) => item?.dependency?.status === 'Completed'
                                  ) ? (
                                  '--'
                                ) : (
                                  <img
                                    className="cursor-pointer"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleDateClick(task?.id, 'start');
                                    }}
                                    src={CalenderIcon}
                                    alt="calenderIcon"
                                  />
                                ))}
                            </td>

                            <td className="px-4 py-2">
                              {task.planned_end_date ? formatDate(task.planned_end_date) : '--'}
                            </td>

                            <td className="px-4 py-2">
                              <div className="flex items-center justify-center w-full relative">
                                {task.engineerLiveTaskMapping?.length > 0 ? (
                                  <div
                                    className="flex -space-x-3"
                                    onClick={(e) => {
                                      handleImageClick(task.id, 'engineer');
                                      setUnique(false);
                                      e.stopPropagation();
                                    }}>
                                    {task.engineerLiveTaskMapping.map((engineer, index) => (
                                      <div
                                        key={engineer.id}
                                        className={`w-6 h-6 rounded-full ${getUserColor(engineer?.user?.id)} text-white flex items-center justify-center text-[0.8rem] font-semibold border-2 border-white leading-none cursor-pointer`}
                                        style={{
                                          zIndex: task.engineerLiveTaskMapping.length - index
                                        }}>
                                        {engineer?.user?.name?.charAt(0).toUpperCase()}
                                      </div>
                                    ))}
                                  </div>
                                ) : (
                                  <img
                                    src={DP}
                                    alt=""
                                    className="cursor-pointer"
                                    onClick={(e) => {
                                      handleImageClick(task.id, 'engineer');
                                      setUnique(false);
                                      e.stopPropagation();
                                    }}
                                  />
                                )}
                              </div>
                            </td>

                            <td className="px-4 py-2">
                              <div className="flex items-center justify-center w-full relative">
                                {task.spLiveTaskMapping?.some(
                                  (contractor) =>
                                    contractor?.user?.serviceProvider?.category_id === 1
                                ) ? (
                                  <div
                                    className="flex -space-x-3"
                                    onClick={(e) => {
                                      handleImageClick(task.id, 'contractor');
                                      setUnique(false);
                                      e.stopPropagation();
                                    }}>
                                    {task.spLiveTaskMapping
                                      ?.filter(
                                        (contractor) =>
                                          contractor?.user?.serviceProvider?.category_id === 1
                                      )
                                      .map((contractor, index) => (
                                        <div
                                          key={contractor.id}
                                          className={`w-6 h-6 rounded-full ${getUserColor(contractor?.user?.id)} text-white flex items-center justify-center text-[0.8rem] font-semibold border-2 border-white leading-none cursor-pointer`}
                                          style={{ zIndex: task.spLiveTaskMapping.length - index }}>
                                          {contractor?.user?.name?.charAt(0).toUpperCase()}
                                        </div>
                                      ))}
                                  </div>
                                ) : (
                                  <img
                                    src={DP}
                                    alt=""
                                    className="cursor-pointer"
                                    onClick={(e) => {
                                      handleImageClick(task.id, 'contractor');
                                      setUnique(false);
                                      e.stopPropagation();
                                    }}
                                  />
                                )}
                              </div>
                            </td>
                            <td className="px-4 py-2">
                              <div className="flex items-center justify-center w-full relative">
                                {task?.drawing_required ? (
                                  task.architectLiveTaskMapping?.some(
                                    (architect) =>
                                      architect?.user?.serviceProvider?.category_id === 2
                                  ) ? (
                                    <div
                                      className="flex -space-x-3"
                                      onClick={(e) => {
                                        handleImageClick(task.id, 'architect');
                                        setUnique(false);
                                        e.stopPropagation();
                                      }}>
                                      {task.architectLiveTaskMapping
                                        ?.filter(
                                          (architect) =>
                                            architect?.user?.serviceProvider?.category_id === 2
                                        )
                                        .map((architect, index) => (
                                          <div
                                            key={architect.id}
                                            className={`w-6 h-6 rounded-full ${getUserColor(architect?.user?.id)} text-white flex items-center justify-center text-[0.8rem] font-semibold border-2 border-white leading-none cursor-pointer`}
                                            style={{
                                              zIndex: task.architectLiveTaskMapping.length - index
                                            }}>
                                            {architect?.user?.name?.charAt(0).toUpperCase()}
                                          </div>
                                        ))}
                                    </div>
                                  ) : (
                                    <img
                                      src={DP}
                                      alt=""
                                      className="cursor-pointer"
                                      onClick={(e) => {
                                        handleImageClick(task.id, 'architect');
                                        setUnique(false);
                                        e.stopPropagation();
                                      }}
                                    />
                                  )
                                ) : (
                                  'N/A'
                                )}
                              </div>
                            </td>
                            <td className="px-4 py-2">
                              <TableData data={task.status} />
                            </td>
                            {/* <td className="px-4 py-2">
                        {Number(task.material_budget) + Number(task.labour_budget) || '---'}
                      </td>
                      <td className="px-4 py-2">
                        {task.materialTaskMapping?.length > 0
                          ? task.materialTaskMapping.map((item) => item.name).join(', ')
                          : '---'}
                      </td> */}
                          </tr>
                        </React.Fragment>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={9} className="text-center py-7">
                        <div className="flex flex-col items-center justify-center">
                          <img
                            src={noDataIcon}
                            alt="No Data"
                            className="w-[25rem] h-[20rem] object-cover"
                          />
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {/* <PaginationComponent
          page={currentPage}
          totalPages={Math.ceil(tasks?.length / itemsPerPage)}
          onPageChange={handlePageChange}
          isFetching={isFetching}
        /> */}
            </InfiniteScroll>
          </div>
        </div>
      )}
      {hidePreviewTable && (
        <div className="pt-[7rem]">
          <div className="shadow overflow-auto rounded-lg">
            <InfiniteScroll
              dataLength={allTasks.length}
              next={loadMore}
              hasMore={hasNextPage}
              loader={
                <div className="flex justify-center items-center py-4">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                  <span className="ml-2 text-gray-600">Loading more tasks...</span>
                </div>
              }
              endMessage={
                <div className="flex justify-center items-center py-4">
                  <p className="text-gray-500">No more tasks to load</p>
                </div>
              }
              style={{ overflow: 'visible' }}>
              <table className="min-w-full rounded-t-xl text-left">
                <thead className=" bg-gray-200 !text-gray-600 ">
                  <tr className="font-normal h-[3rem]">
                    <th className="px-3 py-2 border-b font-normal ">ID</th>
                    <th className="px-3 py-2 border-b font-normal ">WorkType</th>
                    <th className="px-3 py-2 border-b font-normal">Task Name</th>
                    <th className="px-3 py-2 border-b font-normal">Planned Start Date</th>
                    <th className="px-3 py-2 border-b font-normal">Planned End Date</th>
                    <th className="px-3 py-2 border-b font-normal">Actual Start Date</th>
                    <th className="px-3 py-2 border-b font-normal">Actual End Date</th>
                    <th className="px-3 py-2 border-b font-normal">Status</th>
                    <th className="px-3 py-2 border-b font-normal">Delay</th>
                    <th className="px-4 py-2 border-b font-normal">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    let rowIndex = 1; // Start the index from 1

                    return formatted.map((task) => {
                      const rows = [];

                      // Main task row
                      rows.push(
                        <tr
                          key={task.id}
                          className="border-b bg-white h-[3.5rem]"
                          onClick={() => {
                            setApiType('independent');
                            setSelectedTaskId(task.id);
                            toggleDrawer('right', true);
                          }}>
                          <td className="px-4 py-2 text-blue-600 underline cursor-pointer">
                            {rowIndex++}
                          </td>
                          <td className="px-4 py-2 cursor-pointer">{task.workType}</td>
                          <td className="px-4 py-2">{task.name}</td>
                          <td className="px-4 py-2">{formatDate(task.planned_start_date)}</td>
                          <td className="px-4 py-2">{formatDate(task.planned_end_date)}</td>
                          <td className="px-4 py-2">{formatDate(task.actual_start_date)}</td>
                          <td className="px-4 py-2">{formatDate(task.actual_end_date)}</td>
                          <td className="px-4 py-2">{task.status}</td>
                          <td className="px-4 py-2 text-red-600">{calculateDelay(task)}</td>
                          <td className="px-4 py-[1.45rem] flex space-x-2 items-center text-gray-600">
                            {task.status !== 'Completed' && (
                              <Pencil
                                className="w-4 h-4 cursor-pointer hover:text-blue-500"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleOnEdit(task.id);
                                  setTaskPositionType('First');
                                }}
                              />
                            )}

                            <div className="relative group">
                              <Plus
                                className="w-4 h-4 cursor-pointer hover:text-purple-500"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setIsOpenAddEditModal(true);
                                  setModalType('Add');
                                  setPreviousTask(task);
                                  setTaskPositionType('First');
                                }}
                              />
                              <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 whitespace-nowrap text-xs bg-black text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
                                Add new task
                              </div>
                            </div>
                            <Trash
                              className="w-4 h-4 cursor-pointer hover:text-red-500"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleCheckDelete(task.id);
                              }}
                            />
                          </td>
                        </tr>
                      );

                      // Subtasks (Others)
                      task.Others.forEach((sub) => {
                        rows.push(
                          <tr
                            key={sub.id}
                            className="border-b bg-gray-50 h-[3.5rem]"
                            onClick={() => {
                              setApiType('independent');
                              setSelectedTaskId(sub.id);
                              toggleDrawer('right', true);
                            }}>
                            <td className="px-4 py-2 text-blue-600 underline cursor-pointer">
                              {rowIndex++}
                            </td>
                            <td className="px-4 py-2 text-blue-600 underline cursor-pointer"></td>
                            <td className="px-4 py-2">{sub.name}</td>
                            <td className="px-4 py-2">{formatDate(sub.planned_start_date)}</td>
                            <td className="px-4 py-2">{formatDate(sub.planned_end_date)}</td>
                            <td className="px-4 py-2">{formatDate(sub.actual_start_date)}</td>
                            <td className="px-4 py-2">{formatDate(sub.actual_end_date)}</td>
                            <td className="px-4 py-2">{sub.status}</td>
                            <td className="px-4 py-2 text-red-600">{calculateDelay(sub)}</td>
                            <td className="px-4 py-[1.45rem] flex space-x-2 items-center text-gray-600">
                              {sub.status !== 'Completed' && (
                                <Pencil
                                  className="w-4 h-4 cursor-pointer hover:text-blue-500"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleOnEdit(sub.id);
                                    setTaskPositionType('Other');
                                  }}
                                />
                              )}
                              <div className="relative group">
                                <Plus
                                  className="w-4 h-4 cursor-pointer hover:text-purple-500"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setTaskPositionType('Other');
                                    setModalType('Add');
                                    setPreviousTask(sub);
                                    setIsOpenAddEditModal(true);
                                  }}
                                />
                                <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 whitespace-nowrap text-xs bg-black text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
                                  Add new task
                                </div>
                              </div>
                              <Trash
                                className="w-4 h-4 cursor-pointer hover:text-red-500"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleCheckDelete(sub.id);
                                }}
                              />
                            </td>
                          </tr>
                        );
                      });

                      return rows;
                    });
                  })()}
                </tbody>
              </table>
            </InfiniteScroll>
          </div>
        </div>
      )}
      <SwipeableDrawer
        anchor={'right'}
        open={state['right']}
        onClose={() => {
          toggleDrawer('right', false);
          setSelectedTaskId(null);
        }}
        onOpen={() => () => toggleDrawer('right', true)}>
        <TaskDetailsPage
          apiType={apiType}
          taskID={selectedTaskId}
          drawerState={state?.right}
          callApi={refetchCommonLiveTask}
        />
      </SwipeableDrawer>

      {/* Assign Users Modal */}
      {isAssignUsersModalOpen && (
        <Modal
          isDirty={true}
          width={50}
          name="Assign Users to Tasks"
          onClose={() => setIsAssignUsersModalOpen(false)}>
          <UserSelectionModal
            selectedItems={selectedItems}
            allUsers={AllUsers}
            selectedEngineers={selectedEngineers}
            setSelectedEngineers={setSelectedEngineers}
            selectedContractors={selectedContractors}
            setSelectedContractors={setSelectedContractors}
            setIsAssignUsersModalOpen={setIsAssignUsersModalOpen}
            handleAssignUsersSubmit={handleAssignUsersSubmit}
            AllContractors={AllContractors}
          />
        </Modal>
      )}

      {/* Bulk Complete Modal */}
      {isBulkCompleteModalOpen && (
        <BulkCompleteModal
          isOpen={isBulkCompleteModalOpen}
          onClose={() => setIsBulkCompleteModalOpen(false)}
          tasks={tasks}
          workTypes={transformedDataWorkTypes}
          onBulkComplete={handleBulkCompleteSubmit}
          isSubmitting={isSubmitting}
          showWorktypeSelection={true}
          title="Mark Tasks as Complete"
        />
      )}

      {/* Engineer Bulk Assignment Modal */}
      <BulkEngineerAssignmentModal
        isOpen={isEngineerBulkAssignModalOpen}
        onClose={() => setIsEngineerBulkAssignModalOpen(false)}
        workTypes={transformedDataWorkTypes}
        allUsers={AllUsers}
        tasks={tasks}
        onAssignEngineers={handleBulkEngineerAssignment}
        isSubmitting={isSubmitting}
        getUserColor={getUserColor}
        setIsSubmitting={setIsSubmitting}
      />

      {/* Contractor Bulk Assignment Modal */}
      <BulkContractorAssignmentModal
        isOpen={isContractorBulkAssignModalOpen}
        onClose={() => setIsContractorBulkAssignModalOpen(false)}
        workTypes={transformedDataWorkTypes || []}
        allContractors={AllContractors?.data || []}
        tasks={tasks}
        onAssignContractors={handleBulkContractorAssignment}
        isSubmitting={isSubmitting}
        getUserColor={getUserColor}
        setIsSubmitting={setIsSubmitting}
        levels={[]}
        units={[]}
        refetchContractors={ContractorsMutation}
      />

      {/* Bulk Action Modal */}
      {isBulkActionModalOpen && (
        <BulkActionModal
          isOpen={isBulkActionModalOpen}
          onClose={() => setIsBulkActionModalOpen(false)}
          onActionSelect={(actionType) => {
            setIsBulkActionModalOpen(false);

            switch (actionType) {
              case 'assign_employee':
                fetchWorkTypes();
                UsersMutation();
                setIsEngineerBulkAssignModalOpen(true);
                break;
              case 'assign_contractor':
                ContractorsMutation();
                fetchWorkTypes();
                refetchUnits();
                setIsContractorBulkAssignModalOpen(true);
                break;
              case 'assign_architect':
                handleImageClick(null, 'architect');
                break;
              case 'complete_task':
                fetchWorkTypes();
                setIsBulkCompleteModalOpen(true);
                break;
              default:
                break;
            }
          }}
          isSubmitting={isSubmitting}
        />
      )}

      {/* Add Service Provider Modal */}
      {showAddSPModal && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          width={60}
          name="Add Service Provider"
          onClose={() => setShowAddSPModal(false)}>
          <AddServiceProvider
            isSubmitting={isSubmittingSP}
            modalType="Add"
            onSubmit={handleCreateServiceProvider}
            onClose={() => setShowAddSPModal(false)}
            selectedServiceProvider={null}
            setSelectedServiceProvider={() => { }}
            setModalType={() => { }}
            setOpenAddUser={setShowAddSPModal}
            OpenAddUser={showAddSPModal}
            refetchServiceProviders={() => { }}
          />
        </Modal>
      )}
    </div>
  );
};

export default IndependentLiveTasks;
